import { shallowEqual, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export function useCurrentAction() {
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  const userUrl = useSelector((state) => state.user.userUrl, shallowEqual);
  const { actions } = userUrl.find((url) => {
    return url.url.replace("/", "") === path ?? {};
  });
  return actions;
}
